__turbopack_context__.v({
  "chip": "CheckoutChip-module-scss-module__ntHNTG__chip",
});
